import { render } from "./FullScreenLoader.vue?vue&type=template&id=6ceb92bb&scoped=true"
import script from "./FullScreenLoader.vue?vue&type=script&lang=js"
export * from "./FullScreenLoader.vue?vue&type=script&lang=js"

import "./FullScreenLoader.vue?vue&type=style&index=0&id=6ceb92bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ceb92bb"]])

export default __exports__